<template>
  <div class="contact-bubble">
    <BubbleHeader v-if="isDocument">{{message.message_description}}</BubbleHeader>
    <BubbleHeader v-else-if="message.subject">{{message.subject}}</BubbleHeader>

    <MsgblContent class="files-container"
                  :type="message.direction"
                  v-if="isDocument && message.documents">

      <MsgblTextRow v-if="!canViewDocuments" class="no-permission">
        <VSvgIcon tag="24" size="24" icon="document" class="document-icon" />
        <MsgblTextValue>{{$t('document.no_permission')}}</MsgblTextValue>
      </MsgblTextRow>

      <template v-else>
        <MsgblTextRow class="file-row"
                      v-for="f in messageDocuments"
                      :key="f.uid">
          <div class="navigate-area" @click="openDocumentPage(f)">
            <VSvgIcon tag="24" size="24" icon="document" />
            <span class="file-name">{{f.title}}</span>
          </div>

          <span class="file-size">{{f.size_in_kb}}</span>

          <VcButton v-if="hasDocuforms"
                    :icon="true"
                    x-small
                    @click="openDocumentPage(f)">
            <template slot="prepend">
              <VcIcon>icon-Eye-open</VcIcon>
            </template>
          </VcButton>

          <VSvgIcon v-else
                    class="doc-download"
                    tag="16" size="16" icon="download"
                    @click="doDownload(f)"/>
        </MsgblTextRow>

        <MsgblTextRow v-if="hasDeletedDocuments"
                      class="file-row">
          <div class="file-name file-name--deleted">
            {{$t('document.missing_document')}}
          </div>
        </MsgblTextRow>
      </template>

    </MsgblContent>

    <div class="contact-fields">
      <MsgblTextRow v-if="message.text" :has-padding="false">
        <MsgblTextValue>
          <BubbleTextMsg :text="message.text" />
        </MsgblTextValue>
      </MsgblTextRow>

      <MsgblTextRow :has-padding="false"
                    v-for="(row, i) in message.data"
                    :key="i">
        <div v-if="row[0] && row[1]">
          <MsgblTextLabel>{{row[0]}}:</MsgblTextLabel>
          <MsgblTextValue v-if="isLink(row[1])"><a :href="row[1]" target="_blank">{{row[1]}}</a></MsgblTextValue>
          <MsgblTextValue v-else>{{row[1]}}</MsgblTextValue>

          <v-tooltip top v-if="row[2]">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" size="12">
                icon-Information
              </v-icon>
            </template>
            <span>{{$t('conversation.info.new_data_tooltip')}}</span>
          </v-tooltip>
        </div>
      </MsgblTextRow>

    </div>
  </div>
</template>

<script>
import {VSvgIcon} from '@/modules/common/components'
import {urlUtil} from '@/modules/common/utils'

import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblContent,
  MsgblTextRow,
  MsgblTextLabel,
  MsgblTextValue,
} from './helpers'

export default {
  name: 'ContactBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
    MsgblTextRow,
    MsgblContent,
    MsgblTextLabel,
    MsgblTextValue,
    VSvgIcon
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isDocument() {
      return this.message.message_of === 'document'
    },
    canViewDocuments() {
      return this.$hasPermission('can_view_documents')
    },
    hasDocuforms() {
      return this.$hasFeature('new_documents');
    },
    messageDocuments() {
      return this.message.documents.filter(document => !!document);
    },
    hasDeletedDocuments() {
      return this.message.documents.some(document => !document);
    }
  },
  methods: {
    openDocumentPage(file) {
      this.$frontageApi.navigateTo('app.document.show', {uid: file.uid});
    },
    doDownload(file) {
      const data = {file}
      this.$frontageApi.send('document-bubble-action', {action: 'download', data})
    },
    isLink(value) {
      return urlUtil.isUrl(value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';
@import '@/assets/scss/abstract/_i18n-mixins';

.contact-bubble {

  .no-permission {
    display: flex;
    align-items: center;
    padding: 10px;

    .document-icon {
      @include i-margin-mirror(0, 5px);
    }
  }

  .files-container {
    margin-bottom: 5px;
  }

  .file-row {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    &:first-child {
      padding-top: 10px;
    }

    .file-name {
      color: $addToListColor;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      vertical-align: middle;
      @include i-margin-mirror(5px, 20px);

      &--deleted {
        color: unset;
      }

      &:before {
        content: '';
        height: 24px;
        line-height: 24px;
      }
    }

    .navigate-area {
      cursor: pointer;
      display: flex;
      flex: 1;
      overflow: hidden;
    }

    .file-size {
      white-space: nowrap;
      @include i-margin-mirror(0, 7px);
      color: $grey-color-9;
      font-size: 10px;
    }

    .doc-download {
      cursor: pointer;
    }

    .VcButton {

      .v-icon {
        color: $addToListColor;
      }
    }
  }
}
</style>
